import React, { memo } from "react";
import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import useCreateMerchantDialog from "./index.hooks";
import StoreMallDirectoryRoundedIcon from "@material-ui/icons/StoreMallDirectoryRounded";
import { CreateMerchantForm } from "components";

type AddMerchantDialogProps = {} & Omit<DialogProps, "open">;

const CreateMerchantDialog = ({ ...props }: AddMerchantDialogProps) => {
  const { styles, classes, isOpen, onClose, t } = useCreateMerchantDialog();

  return (
    <Dialog onClose={onClose} open={isOpen} {...props} classes={classes.dialog}>
      <Avatar className={styles.dialogAvatar}>
        <StoreMallDirectoryRoundedIcon className={styles.dialogIcon} />
      </Avatar>
      <DialogTitle>{t("Registra una nuova attivit\u00E1!")}</DialogTitle>
      <DialogContent>
        <CreateMerchantForm />
      </DialogContent>
    </Dialog>
  );
};

export default memo(CreateMerchantDialog);
